import PropTypes from 'prop-types';
import { NavLink as RouterLink } from 'react-router-dom';
import { useState } from 'react';
import { Box, Collapse, List, ListItemText } from '@mui/material';
// eslint-disable-next-line import/no-unresolved
import Iconify from 'components/iconify';
import { StyledNavItem, StyledNavItemIcon } from './styles';

NavSection.propTypes = {
  data: PropTypes.array,
};

export default function NavSection({ data = [], ...other }) {
  return (
    <Box {...other}>
      <List disablePadding sx={{ p: 0.5 }}>
        {data.map((item, index) => (
          <NavItem key={index} item={item} />
        ))}
      </List>
    </Box>
  );
}

NavItem.propTypes = {
  item: PropTypes.object,
};

function NavItem({ item }) {
  const { title, path, icon, info, children } = item;
  const [open, setOpen] = useState(false);

  const hasChildren = Array.isArray(children) && children.length > 0;

  const handleClick = () => {
    if (hasChildren) setOpen(!open);
  };

  return (
    <>
      <StyledNavItem
        component={hasChildren ? 'div' : RouterLink}
        to={!hasChildren ? path : undefined}
        onClick={handleClick}
      >
        <StyledNavItemIcon>{icon && icon}</StyledNavItemIcon>
        <ListItemText disableTypography primary={title} sx={{ fontSize: 14 }} />
        {info && info}
        {hasChildren &&
          (open ? (
            <Iconify icon="mdi:chevron-up" sx={{ width: 16, height: 16 }} />
          ) : (
            <Iconify icon="mdi:chevron-down" sx={{ width: 16, height: 16 }} />
          ))}
      </StyledNavItem>
      {hasChildren && (
        <Collapse in={open} timeout="auto" unmountOnExit>
          <List component="div" disablePadding sx={{ pl: 2.5 }}>
            {children.map((child, idx) => (
              <NavItem key={idx} item={child} />
            ))}
          </List>
        </Collapse>
      )}
    </>
  );
}
